import React from 'react';
import { Field } from 'formik';

import { Grid, InputAdornment } from '@material-ui/core';

import TextFieldFormik from 'app/components/form/formik/TextFieldFormik';
import { AssetHistoryForm } from 'features/equipment/assets/components/equipmentTest/form-utils/AssetHistoryForm';

const CableContinuityFormComponent = () => {
  return (
    <>
      <Grid container>
        <Grid item xs={12} container>
          <Field
            type="number"
            destroyOnUnmount
            label="Resistance"
            component={TextFieldFormik}
            name={AssetHistoryForm.CABLE_CONTINUITY_TEST_RESISTANCE}
            InputProps={{
              endAdornment: <InputAdornment position="end">ohm</InputAdornment>,
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default CableContinuityFormComponent;
